import { createStyles } from '@mui/styles';
import { APTheme } from '../../../../core/TenantProvider/tenants';

export default (theme: APTheme) => createStyles({

	heading: {
		fontWeight: 500,
		marginBottom: 20
	},
	fieldsContainer: {
		marginBottom: 25,
		'& .autocomplete': {
			position: 'relative'
		},
		'&:last-child': {
			marginBottom: 0
		},
		'& .errorMessage': {
			margin: '0 0 25px 0',
			width: '100%',
			'& .MuiPaper-root': {
				padding: '6px 20px',
			},
			'& .MuiCollapse-wrapperInner': {
				margin: 0,

				'& .MuiAlert-message': {
					padding: '13px 10px',
					'& strong': {
						textTransform: 'uppercase'
					}
				}
			},
		}
	},
	field: {
		width: '100%',
		marginBottom: 25,
		"&:last-child": {
			marginBottom: 0,
		}
	},
	button: {
		display: 'inline-block',
		marginBottom: 20,
		minWidth: 200,
		'&:hover': {
		}
	},
	textButton: {
		minWidth: 'auto',
		padding: 0,
		height: 'auto',
		background: 'none',
		marginBottom: 20,
		display: 'block',
		'&:hover': {
			backgroundColor: 'transparent'
		}
	},
	loadingIcon: {
		display: 'inline-block',
		marginLeft: 15
	},
	selectionSummary: {
		backgroundColor: '#FBFBFB',
		padding: 25,
		'& > div': {
			marginBottom: 15
		}
	},
	summaryLabel: {
		color: '#A4A4A4',
		fontSize: 14,
		marginBottom: 5
	},
	summaryText: {
		textTransform: 'capitalize'
	}
});